import { render, staticRenderFns } from "./Abbreviations.vue?vue&type=template&id=570a0f8f"
import script from "./Abbreviations.vue?vue&type=script&lang=js"
export * from "./Abbreviations.vue?vue&type=script&lang=js"
import style0 from "./Abbreviations.vue?vue&type=style&index=0&id=570a0f8f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports